import * as AppConstants from '@/modules/core/constants/app.constants'

export const APP_USER = `${AppConstants.DOMAIN}.app_user`
